import type { CSSProperties } from 'react'
import { industryEffectByTag } from '../../data/industryEffects'
import type { IndustryEffect } from '../../types/news'

export function IndustryEffectTags({ industries = [] }: { industries?: IndustryEffect[] }) {
  if (!industries.length) return null
  return <div className="industry-effect-tags" aria-label="Industry effects">
    {industries.map((industry) => {
      const definition = industryEffectByTag.get(industry)
      return <span style={{ '--industry-tone': definition?.accent } as CSSProperties} key={industry}>EFFECT · {definition?.shortName.toUpperCase() ?? industry}</span>
    })}
  </div>
}
